var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMuteButton(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 35.7 35.7",
    style: {
      enableBackground: "new 0 0 35.7 35.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 17.8535,
    y1: 35.04,
    x2: 17.8535,
    y2: 0.668
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A043C1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0071BC"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_1_)"
    },
    d: "M23.5,8.6l2-2c-0.3-0.4-0.6-0.7-0.9-1c-0.5-0.5-1.4-0.5-2,0s-0.5,1.4,0,2 C22.9,7.9,23.2,8.2,23.5,8.6z M7.2,25.1l2.2-2.2l-1-0.6H3v-8.8h5.3l8.1-4.7v7l2.8-2.8V7.5c0-0.7-0.4-1.4-1-1.8c-0.6-0.4-1.4-0.4-2,0 l-8.5,4.9H2.2c-1.1,0-2,0.9-2,2V23c0,1.1,0.9,2,2,2H7.2z M27.8,4.2l2-2c-0.3-0.3-0.6-0.7-0.9-1c-0.5-0.5-1.4-0.5-2,0 c-0.5,0.5-0.5,1.4,0,2C27.2,3.5,27.5,3.9,27.8,4.2z M32.7,6.4l-2.1,2.1c1.3,2.7,2.1,5.7,2.1,8.8c0,5.8-2.5,11.3-6.9,15.1 c-0.6,0.5-0.7,1.4-0.1,2c0.3,0.3,0.7,0.5,1.1,0.5c0.3,0,0.6-0.1,0.9-0.3c5-4.3,7.9-10.6,7.9-17.2C35.5,13.4,34.6,9.7,32.7,6.4z  M28.2,11L26,13.2c0.4,1.3,0.6,2.7,0.6,4.1c0,3.9-1.6,7.6-4.5,10.2c-0.6,0.5-0.6,1.4-0.1,2c0.3,0.3,0.7,0.5,1,0.5 c0.3,0,0.7-0.1,0.9-0.4c3.5-3.1,5.4-7.6,5.4-12.3C29.4,15.1,29,13,28.2,11z M34.5,1.1c-0.5-0.5-1.4-0.5-2,0L1.2,32.7 c-0.5,0.5-0.5,1.4,0,2c0.3,0.3,0.6,0.4,1,0.4c0.4,0,0.7-0.1,1-0.4L34.5,3.1C35.1,2.5,35.1,1.6,34.5,1.1z M16.4,26.9l-2.5-1.5l-2,2.1 l4.3,2.5c0.3,0.2,0.7,0.3,1,0.3s0.7-0.1,1-0.3c0.6-0.4,1-1,1-1.8v-8.1l-2.8,2.8V26.9z"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMuteButton);
export default __webpack_public_path__ + "static/media/mute_button.7a5ad443ba8ef820d452dbe23262612c.svg";
export { ForwardRef as ReactComponent };